import { SVGProps } from "react";

const Archive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.7502 7.125L3.7502 19.125C3.75168 19.6218 3.9497 20.0979 4.30101 20.4492C4.65232 20.8005 5.12837 20.9985 5.6252 21H18.3752C18.872 20.9985 19.3481 20.8005 19.6994 20.4492C20.0507 20.0979 20.2487 19.6218 20.2502 19.125L20.2502 7.125"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4376 3L3.56258 3C2.83771 3 2.25008 3.58763 2.25008 4.3125L2.25008 5.4375C2.25008 6.16237 2.83771 6.75 3.56258 6.75L20.4376 6.75C21.1625 6.75 21.7501 6.16237 21.7501 5.4375V4.3125C21.7501 3.58763 21.1625 3 20.4376 3Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M15.0007 14.25L12.0007 17.25L9.00069 14.25"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16.2136L12 10.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Archive;
